import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="ag-card" style={{ maxWidth: '820px', margin: '0 auto' }}>
      <h1>Politique de confidentialité</h1>
      <p>
        Chez AgroShop, vos données sont protégées et utilisées uniquement pour vous offrir une expérience de
        commande fluide et sécurisée. Nous respectons la confidentialité de vos informations personnelles,
        y compris votre nom, email, téléphone et adresse de livraison.
      </p>

      <section style={{ marginTop: '24px' }}>
        <h2>Données collectées</h2>
        <ul>
          <li>Informations de contact (nom, email, téléphone)</li>
          <li>Adresse de livraison et préférences de retrait</li>
          <li>Données de panier et d’achat pour traiter votre commande</li>
          <li>Cookies et identifiants de session nécessaires au fonctionnement du site</li>
        </ul>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2>Comment nous protégeons vos données</h2>
        <ul>
          <li>Les échanges avec notre site sont chiffrés via HTTPS/SSL.</li>
          <li>Les mots de passe ne sont jamais stockés en clair.</li>
          <li>Les informations de paiement sont traitées par des prestataires sécurisés.</li>
          <li>Les cookies sont utilisés de manière responsable pour améliorer votre expérience.</li>
        </ul>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2>Utilisation des données</h2>
        <p>
          Nous utilisons vos informations pour :
        </p>
        <ul>
          <li>Traiter vos commandes et livraisons</li>
          <li>Améliorer notre plateforme et personnaliser votre expérience</li>
          <li>Répondre à vos demandes de support</li>
          <li>Envoyer des notifications liées à votre compte et à vos commandes</li>
        </ul>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2>Vos droits</h2>
        <p>
          Vous pouvez nous contacter à tout moment pour demander la mise à jour, la suppression ou l’accès à vos
          données. Consultez notre page de contact ou envoyez un email à <strong>it43694@gmail.com</strong>.
        </p>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2>Questions ?</h2>
        <p>
          Pour plus d’informations, retournez à l’accueil ou contactez-nous par email à <strong>it43694@gmail.com</strong>.
        </p>
      </section>
    </div>
  );
}
